/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/ResourceItem/Input
 * @desc ProtocolValue Info
 */

import { FormShowEditSearchSelectModal } from 'labstep-web/core/Form/ShowEdit/SearchSelect/Modal';
import React from 'react';
import type { IProtocolValueFormShowEditResourceItemInputProps } from './types';
import { getProps } from './utils';

export const ProtocolValueFormShowEditResourceItemInput: RFC<
  IProtocolValueFormShowEditResourceItemInputProps
> = ({ protocolValue, children, type = 'button' }) => (
  <FormShowEditSearchSelectModal
    dataCy="components/ProtocolValue/Form/ShowEdit/ResourceItem/Input"
    {...getProps(protocolValue, children, type)}
  />
);
